
export default () => {


  if ($('.js-view-pricing-link').length) {
    $('.js-view-pricing-link').on('click', (e) => {
      e.preventDefault();
      handleDialog($('#gated-pricing-modal'));
    });
  }

  // $('.js-schedule-visit-link')
  //   .on('click', function(e) {
  //     e.preventDefault();

  //     // console.log('Dialog: ', "dialog");
  //     const dialogContainer = $(this)
  //       .siblings('#gated-pricing-modal');
  //     handleDialog(dialogContainer);
  //   });

  function handleDialog(dialogContainer) {
    const dialogNativeDom = dialogContainer[0];
    const $dialogCloseButton = dialogContainer.find('.gated-pricing-modal-close');

    dialogNativeDom.setAttribute('data-open', 'true');

    // Add the event listener once is open.
    $dialogCloseButton.on('click', () => {
      dialogNativeDom.setAttribute('data-open', 'false');
      $dialogCloseButton.off('click');
    });
  }
};
